import { Notify } from '~/lib/notify'
import { useI18n } from 'vue-i18n'
import { useClipboard } from '@vueuse/core'

export function useCopyToClipboard() {
  const clipboard = useClipboard()
  const { t } = useI18n()

  function contentAsString(content: unknown): string {
    if (typeof content === 'string') {
      return content
    }

    return JSON.stringify(content)
  }

  async function copy(content: unknown) {
    try {
      const text = contentAsString(content)
      await clipboard.copy(text)
      Notify.success(t('CopiedToClipboard'))
    } catch (e) {
      console.error(e)
      console.log(content)
      Notify.error(t('CopiedToClipboardFailed'))
    }
  }
  return {
    copy,
  }
}
